import Tools from '../../tools/Tools';
export default class Step3{
	constructor(view){
		console.log('Step3 :: init',view);

		this.view 		= view;
		this.inputs 	= this.view.querySelectorAll('input');
		this.content	= this.view.querySelector('.content');
		this.package	= this.content.querySelector('.package_wrapper.hidden');
		this.template	= this.package.cloneNode(true);

		this.package.remove();
		this.template.classList.remove('hidden');

	}

	load(response, max, currency){
		console.log('Step 3 :: Load :: ',response);
		let options = response.options;

		this.content.innerHTML = "";

		for(let i = 0; i < options.length; i++){
			let newPackage 	= this.template.cloneNode(true),
				current 	= options[i],
				id			= current['id'],
				label		= current['label'],
				items		= current['items'],
				priceRaw	= current['price']['raw'],
				price		= current['price']['formatted'];

			newPackage.querySelector('.pane').innerHTML 	= (i+1);
			newPackage.querySelector('label').htmlFor 		= 'option_'+id;
			newPackage.querySelector('input').id 			= 'option_'+id;
			newPackage.querySelector('p.bigger strong').innerHTML 	= label;
			newPackage.querySelector('.max').innerHTML 		= max;

			if(priceRaw == 0) newPackage.querySelector('.bot').remove();
			else {
				newPackage.querySelector('.price').innerHTML = price;
				let sup = document.createElement('sup');
				sup.innerHTML = currency;
				newPackage.querySelector('.price').appendChild(sup);
			}

			for(let j = 0; j < items.length; j++){
				let p = document.createElement('p');
				p.innerHTML = items[j];
				newPackage.querySelector('.top .left').appendChild(p);
			}

			this.content.appendChild(newPackage);
		}
		Tools.scrollTo(0,$(document.querySelector('section.reservation .container')).offset().top - 40);

		this.inputs = this.view.querySelectorAll('input');
	}

	updateMax(){
		this.number.innerHTML = this.current =this.max;
	}

	updatePeople(){
		this.people.innerHTML = this.max;
	}
}